import type { ReactNode } from "react";

import styles from "./McpAccessPage.module.css";

export type SnippetKind = "claude-code" | "mcp-json" | "claude-desktop";

export const SNIPPET_OPTIONS: { value: SnippetKind; label: string }[] = [
  { value: "claude-code", label: "Claude Code" },
  { value: "mcp-json", label: ".mcp.json" },
  { value: "claude-desktop", label: "Claude Desktop" },
];

export interface Snippet {
  /** What the dark block shows, coloured. */
  node: ReactNode;
  /** What Copy puts on the clipboard: the block without its comment line,
   *  because zsh runs a pasted "# …" line as a command. */
  copy: string;
}

const c = (text: string) => <span className={styles.c}>{text}</span>;
const s = (text: string) => <span className={styles.s}>{text}</span>;
const k = (text: string) => <span className={styles.k}>{text}</span>;

export function buildSnippet(
  kind: SnippetKind,
  serverName: string,
  serverUrl: string,
): Snippet {
  switch (kind) {
    case "claude-code": {
      const command = `claude mcp add --transport http \\\n  ${serverName} \\\n  ${serverUrl}`;
      return {
        node: (
          <>
            {c("# add once, then run /mcp → Authenticate")}
            {"\nclaude mcp add --transport http \\\n  "}
            {s(serverName)}
            {" \\\n  "}
            {s(serverUrl)}
          </>
        ),
        copy: command,
      };
    }
    case "mcp-json": {
      // JSON.stringify is the source of truth for the clipboard, so a name or
      // URL with a quote in it still pastes as valid JSON.
      const copy = JSON.stringify(
        { mcpServers: { [serverName]: { type: "http", url: serverUrl } } },
        null,
        2,
      );
      return {
        node: (
          <>
            {"{\n  "}
            {k('"mcpServers"')}
            {": {\n    "}
            {k(JSON.stringify(serverName))}
            {": {\n      "}
            {k('"type"')}
            {": "}
            {s('"http"')}
            {",\n      "}
            {k('"url"')}
            {": "}
            {s(JSON.stringify(serverUrl))}
            {"\n    }\n  }\n}"}
          </>
        ),
        copy,
      };
    }
    case "claude-desktop":
      return {
        node: (
          <>
            {c("# Settings → Connectors → Add custom connector")}
            {"\n"}
            {k("Name")}
            {"  "}
            {s(serverName)}
            {"\n"}
            {k("URL")}
            {"   "}
            {s(serverUrl)}
          </>
        ),
        copy: `Name  ${serverName}\nURL   ${serverUrl}`,
      };
  }
}
